import { Autocomplete, TextField } from '@mui/material';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import {
  selectDefaultModDetails,
  selectIsEditMod,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { formatTypeAheadOptions } from '../../ModificationsUtils';

export const ShiftField = () => {
  const {
    control,
    setValue,
    register,
    formState: { errors },
    setError,
    clearErrors,
    formState: { dirtyFields },
  } = useFormContext();
  const { t } = useTranslation();
  const shiftDescription = 'shiftDescription';
  const isModEdit = useSelector(selectIsEditMod);
  register('shiftId');
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [shiftOption, setShiftOption] = useState([]);
  const selectedModsDetails = useSelector(selectDefaultModDetails);
  const isUndoModal = useSelector(selectIsUndoModal);
  const [defaultOption, setDefaultOption] = useState<any>([]);
  const [required, setRequired] = useState<boolean>(false);

  const getShiftDropDown = async () => {
    const options = await getSearchFilterOptions('shiftlist');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setShiftOption(orderBy(newOptions, 'id', 'asc'));

      const description = findValueBasedOnKey(
        options,
        selectedModsDetails?.shiftDescription,
        (selectedModsDetails?.shiftId).toString(),
      );

      if (selectedModsDetails?.shiftId && description) {
        const defaultVal = {
          Description: description,
          id: selectedModsDetails?.shiftId,
        };
        setDefaultOption(defaultVal);

        setValue(shiftDescription, description);
        setValue('shiftId', selectedModsDetails?.shiftId);
        setRequired(true);
        clearErrors(shiftDescription);
      } else {
        const defaultVal = {
          Description: '',
          id: '',
        };
        setDefaultOption(defaultVal);
        setRequired(true);
        setError(shiftDescription, {});
      }
    }
  };

  const onSelectionChange = value => {
    if (value === null) {
      setValue(shiftDescription, '', { shouldDirty: true });
      setValue('shiftId', '', { shouldDirty: true });
      clearErrors(shiftDescription);
    } else {
      setValue(shiftDescription, value.Description, { shouldDirty: true });
      setValue('shiftId', value.id, { shouldDirty: true });
      clearErrors(shiftDescription);
    }
  };

  const findValueBasedOnKey = (shiftListArray: any, shiftDesc: string, shiftId: string) => {
    return shiftDesc === null ? shiftListArray.find(item => item.value === shiftId)?.name : shiftDesc;
  };

  useEffect(() => {
    getShiftDropDown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModsDetails, isUndoModal, dirtyFields]);

  return (
    <Controller
      control={control}
      name={shiftDescription}
      rules={{ required: required }}
      render={({ field: { onChange, ...rest } }) => (
        <Autocomplete
          options={shiftOption ?? []}
          getOptionLabel={shiftOpt => shiftOpt.Description || ''}
          value={defaultOption}
          disabled={isSaveModApiCalling}
          onChange={(e, value) => {
            setDefaultOption(value);
            onSelectionChange(value);
            onChange(value?.id);
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={t('placement.placementMods.shift')}
              variant="filled"
              error={!!errors?.shiftId}
            />
          )}
          readOnly={!isModEdit}
        ></Autocomplete>
      )}
    />
  );
};
